import { Navigate, Outlet, useParams } from "react-router-dom";
import { useAppSelector } from "hooks";
import { isRoleForCompany } from "features/invoice-approvals/invoice-approvals.slice";

/**
 * Wraps every /app/:companyId/my-work address. A guest member has only «About me»
 * in the cabinet, so they are sent there instead of to tasks they cannot have.
 * Nothing is drawn until the role of the company in the address has loaded: right
 * after a company switch the stored role still belongs to the company just left.
 */
export default function TasksRouteGuard() {
  const { companyId } = useParams();
  const role = useAppSelector((state) => state.authReducer.role);
  const userId = useAppSelector((state) => state.authReducer.session?.id);

  if (!isRoleForCompany(role, companyId)) return null;
  if (role?.isUserGuest && userId) {
    return <Navigate to={`/app/${companyId}/profile/${userId}/info`} replace />;
  }
  return <Outlet />;
}
